export default __webpack_public_path__ + "static/media/rules.db12987f.png";